// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3998
import type { PAPEventGeneric } from "../base/event";
import type { DashExperience } from "../enums/dash_experience";
import type { DashSurface } from "../enums/dash_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";
import type { AiToolCreationFlow } from "../enums/ai_tool_creation_flow";
import type { AiToolType } from "../enums/ai_tool_type";
import type { AiToolAccess } from "../enums/ai_tool_access";

// Event_name: 'create.contextual_ai_tool'
// Description: User creates an AI tool from Chat page
// Owner: dash-assist
export type Create_ContextualAiTool = PAPEventGeneric<
  'dash',
  'create',
  'contextual_ai_tool',
  {
    // The property used to distinguish fss dash and dash standalone features
    dashExperience?: DashExperience;
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // Steps to create AI tool in Dash Chat
    aiToolCreationFlow?: AiToolCreationFlow;
    // User selects which ai tool to create
    aiToolType?: AiToolType;
    // Log AI tool prompt for dash extension feature
    aiToolPrompt?: string;
    // Whether user enables dash search for AI tool
    dashSearchEnabled?: boolean;
    // Whether user enables follow-up suggestions
    followUpSuggestionsEnabled?: boolean;
    // Whether allowing users to add their own sources
    customSourcesAllowed?: boolean;
    // Access permission of AI too
    aiToolAccess?: AiToolAccess;
  }
>;

export function PAP_Create_ContextualAiTool(properties?: Create_ContextualAiTool['properties']): Create_ContextualAiTool {
  return <Create_ContextualAiTool>{
    class: 'dash',
    action: 'create',
    object: 'contextual_ai_tool',
    properties,
  };
}
